<template>
  <router-view />
</template>

<script>
import moment from 'moment';
import 'moment/dist/locale/zh-cn';
moment.locale('zh-cn');
moment.updateLocale('zh-cn', {
  week: {
    dow: 0,
    doy: 6,
  },
});

export default {
  setup() {},
};
</script>
<style lang="less">
@import '~vant/lib/index.css';
@import url('./style/index.less');
html,
body,
#app {
  width: 100vw;
  height: 100%;
  margin: 0 auto;
  background-color: #f5f7f9;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Microsoft YaHei', 'PingFang SC';
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
    Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui',
    'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  -webkit-font-smoothing: antialiased;
  //-webkit-overflow-scrolling: touch;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 16px;
  overflow: hidden;
}
p {
  margin: 0;
}

//公共样式
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  max-width: 100%;
}

:root {
  //--van-white: #fff;
  //--van-blue: #1989fa;
  //--van-button-primary-color: var(--van-white);

  --van-dropdown-menu-option-active-color: var(--van-primary-color);
  --van-switch-on-background-color: var(--van-primary-color);
  --van-button-primary-background-color: var(--van-primary-color);
  --van-dropdown-menu-title-active-text-color: var(--van-primary-color);
}

.van-dropdown-item__option {
  .van-cell__title {
    font-size: 15px;
  }
}

.van-dropdown-menu__title {
  &:after {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom-width: 5px;
    border-bottom-color: #999;
    border-radius: 2px;
    transform: unset;
    top: calc(50% - 3 / 4 * 10px);
    margin: unset;
  }
}

.van-dropdown-menu__title--down {
  &:after {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-width: 5px;
    border-top-color: var(--van-blue);
    border-radius: 2px;
    transform: unset;
    top: calc(50% - 1 / 4 * 10px);
    margin: unset;
  }
}

.van-dropdown-menu__title {
  padding: 0 10px;
}
</style>
